import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const MapFilterStyled = styled(Box)`
  position: absolute;
  ${({ theme }) => css`
    bottom: ${theme.spacings['400']};
    left: ${theme.spacings['400']};
  `}
`;
